import { Badge } from "react-bootstrap";

const DotBadge = ({ children, bg = 'light-primary' }) => {
    return (
        <span className="me-2">
            <Badge bg={bg} className="badge-dot"></Badge> {children}
        </span>
    );
};

export default DotBadge;